export interface MstatusData {
    Description: string;
    MStatusDatas: MStatusData[];
}

interface MStatusData {
    ElementName: string;
    Alias: string;
    ElementGuid: string;
    AttributeGuid: string;
    Description: string;
}

export async function GetMstatusData(elementGuid: string) {
    const apiUrl = process.env.REACT_APP_API_URL;

    const url = `${apiUrl}/teams/mstatus?eguid=${elementGuid}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response.ok) {
            const data: MstatusData = await response.json();
            return data;
        }
    } catch (error) {
        console.error("Failed to fetch data", error);
        return null;
    }
}
